export const DependenceType = {
  PARALLELTHEPREVIOUS: 'PARALLELTHEPREVIOUS',
  AFTERPREVIOUS: 'AFTERPREVIOUS',
  INDEPENDENT: null,
};

export const ItemCodeGenerationMethod = {
  LEGACY: 'LEGACY',
  SZIKAMETRO_FINISHED_PRODUCT: 'SZIKAMETRO_FINISHED_PRODUCT',
  ITEM_GROUP_PREFIX: 'ITEM_GROUP_PREFIX',
};

export const KanbanOrder = {
  CREATEDAT: 'CREATEDAT',
  UPDATEDAT: 'UPDATEDAT',
  STARTDATE: 'STARTDATE',
  ENDDATE: 'ENDDATE',
};

export const KanbanOrderList = [
  { label: 'Létrehozás dátuma', value: KanbanOrder.CREATEDAT },
  { label: 'Módosítás dátuma', value: KanbanOrder.UPDATEDAT },
  { label: 'Kezdő dátum', value: KanbanOrder.STARTDATE },
  { label: 'Befejező dátum', value: KanbanOrder.ENDDATE },
];

export const DependenceTypeList = [
  { label: 'Előzővel párhuzamos', value: DependenceType.PARALLELTHEPREVIOUS },
  { label: 'Előző után', value: DependenceType.AFTERPREVIOUS },
  { label: 'Független', value: DependenceType.INDEPENDENT },
];

export const ItemCodeGenerationMethodList = [
  { label: 'Alapértelmezett', value: ItemCodeGenerationMethod.LEGACY },
  {
    label: 'Szikametro89',
    value: ItemCodeGenerationMethod.SZIKAMETRO_FINISHED_PRODUCT,
  },
  { label: 'Cikkcsoport-prefix alapján', value: ItemCodeGenerationMethod.ITEM_GROUP_PREFIX },
];
